<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">LGA</h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a href="/">Home</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <a href="/">Settings</a>
                                </li>
                                <li class="breadcrumb-item active">LGA</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right ml-1" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Add New LGA</span></button>
                    
                    <button class="btn btn-primary btn-sm pull-right" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button>
                    
                </div>
            </div>

        </div>

    <div class="content-body">
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">
                    <transition name="fade">
                        <div class="card border-bottom" v-if="showCreatePanel">
                            <div class="card-header">
                                <h4 class="card-title">Add New LGA</h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <lga-form @completed="getLGA" @cancel="showCreatePanel = !showCreatePanel"></lga-form>
                            </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="card border-bottom" v-if="showFilterPanel">
                            <div class="card-header">
                                <h4 class="card-title">
                                    {{trans('general.filter')}}
                                </h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">{{trans('general.keyword')}}</label>
                                            <input class="form-control" name="keyword" v-model="filterLGAForm.keyword">
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                            </div>
                            </div>
                        </div>
                    </transition>
                    <div class="card">
                        <div class="card-header">
                            <h4 v-if="lgas.total" class="card-title">
                                <sort-by :order-by-options="orderByOptions" :sort-by="filterLGAForm.sort_by" :order="filterLGAForm.order" @updateSortBy="value => {filterLGAForm.sort_by = value}"  @updateOrder="value => {filterLGAForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <div class="table-responsive" v-if="lgas.total">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>State</th>
                                            <th>Name</th>
                                            <th class="table-option">{{trans('general.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="lga in lgas.data">
                                            <td v-text="lga.state.name"></td>
                                            <td v-text="lga.name"></td>
                                            <td class="table-option">
                                                <div class="btn-group">
                                                    <button class="btn btn-info btn-sm" v-tooltip="'Edit LGA'" @click.prevent="editLGA(lga)"><i class="feather icon-edit"></i></button>
                                                    <button class="btn btn-danger btn-sm" :key="lga.id" v-confirm="{ok: confirmDelete(lga)}" v-tooltip="'Delete LGA'"><i class="feather icon-trash-2"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <module-info v-if="!lgas.total"  module="general" title="module_info_title" description="module_info_description" icon="check-circle">
                                <div slot="btn">
                                    <button class="btn btn-primary btn-md" v-if="!showCreatePanel" @click="showCreatePanel = !showCreatePanel"><i class="feather icon-plus"></i> {{trans('general.add_new')}}</button>
                                </div>
                            </module-info>
                            <pagination-record :page-length.sync="filterLGAForm.page_length" :records="lgas" @updateRecords="getLGA"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   
   </div>
    </div>
</template>

<script>
    import lgaForm from './form'
    import sortBy from '../../../components/sort-by'

    export default {
        components : { lgaForm,sortBy },
        data() {
            return {
                lgas: {
                    total: 0,
                    data: []
                },
                filterLGAForm: {
                    keyword: '',
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: helper.getConfig('page_length')
                },
                orderByOptions: [
                    {
                        value: 'name',
                        translation: 'Name'
                    }
                ],
                showCreatePanel: false,
                showFilterPanel: false
            };
        },
        mounted(){
            if(!helper.hasPermission('access-settings')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            this.getLGA();
        },
        methods: {
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            getLGA(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterLGAForm);
                axios.get('/api/setting/lga?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.lgas = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editLGA(lga){
                this.$router.push('/setting/lga/'+lga.id+'/edit');
            },
            confirmDelete(lga){
                return dialog => this.deleteLGA(lga);
            },
            deleteLGA(lga){
                axios.delete('/api/setting/lga/'+lga.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getLGA();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            }
        },
        watch: {
            filterLGAForm: {
                handler(val){
                    setTimeout(() => {
                        this.getLGA();
                    }, 500)
                },
                deep: true
            }
        }
    }
</script>
